import { useQuery } from '@tanstack/react-query';

import getUser from '@/utils/apiRestCalls/getUser';
import { useUrlChecker } from './useUrlChecker';

export const useUser = () => {
  const { isPublic } = useUrlChecker();
  const { data: user } = useQuery({
    queryKey: ['user'],
    queryFn: () => getUser(),
    staleTime: Infinity,
    enabled: !isPublic,
  });

  return { isPublic, user };
};
